(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tlt-collection-browse"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('tlt-collection-browse')){
    customElements.define('tlt-collection-browse',class extends HTMLElement{
      connectedCallback(){
        if(this.ready)return;
        this.ready=true;
        const buttons=Array.from(this.querySelectorAll('[data-group]'));
        const panels=Array.from(this.querySelectorAll('[data-panel]'));
        const show=group=>{
          buttons.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.group===group)));
          panels.forEach(panel=>panel.hidden=panel.dataset.panel!==group);
        };
        this.querySelector('[data-tabs]').hidden=false;
        show(this.dataset.active);
        buttons.forEach((button,index)=>{
          button.addEventListener('click',()=>show(button.dataset.group));
          button.addEventListener('keydown',event=>{
            if(!['ArrowLeft','ArrowRight'].includes(event.key))return;
            event.preventDefault();
            const next=buttons[(index+(event.key==='ArrowRight'?1:buttons.length-1))%buttons.length];
            show(next.dataset.group);next.focus();
          });
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tlt-seasonal-home"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tlt-seasonal-home')) {
    customElements.define('tlt-seasonal-home', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.buttons = Array.from(this.querySelectorAll('[data-select]'));
        this.current = 0;
        if (this.slides.length < 2) return;
        this.querySelector('[data-controls]').hidden = false;
        this.buttons.forEach((button, index) => button.addEventListener('click', () => this.show(index)));
        this.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => this.show(this.current + Number(button.dataset.step))));
        this.querySelector('.tlt-tabs').addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          this.show(this.current + (event.key === 'ArrowRight' ? 1 : -1));
          this.buttons[this.current].focus();
        });
        this.addEventListener('shopify:block:select', event => {
          const slide = event.target.closest('[data-slide]');
          if (slide) this.show(Number(slide.dataset.slide));
        });
        let start = null;
        const hero = this.querySelector('.tlt-hero');
        hero.addEventListener('touchstart', event => { start = {x: event.changedTouches[0].clientX, y: event.changedTouches[0].clientY}; }, {passive: true});
        hero.addEventListener('touchend', event => {
          if (!start) return;
          const dx = event.changedTouches[0].clientX - start.x;
          const dy = event.changedTouches[0].clientY - start.y;
          if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) this.show(this.current + (dx < 0 ? 1 : -1));
          start = null;
        }, {passive: true});
      }
      show(index) {
        this.current = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => { slide.hidden = i !== this.current; });
        this.buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === this.current)));
        this.querySelector('[data-slide-status]').textContent = this.buttons[this.current].textContent;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
